var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("billing-loading-modal", {
        attrs: {
          text: "Aguarde o upload da fatura.",
          "is-active": _vm.savingBillingUpload
        }
      }),
      _vm._v(" "),
      _c(
        "sc-confirmation-modal",
        {
          attrs: {
            "is-active": _vm.isErrorModalActive,
            type: "primary",
            title: "Adicionar ou reenviar fatura?",
            cancelText: "Adicionar fatura",
            "confirm-text": "Reenviar fatura"
          },
          on: {
            "update:isActive": function($event) {
              _vm.isErrorModalActive = $event
            },
            onConfirm: function() {
              return _vm.$emit("onOverwriteBilling")
            },
            onCancel: function() {
              return _vm.$emit("onDuplicateBilling")
            }
          }
        },
        [
          _c("template", { attrs: { slot: "default" }, slot: "default" }, [
            _c("p", { staticStyle: { "margin-bottom": "16px" } }, [
              _vm._v(
                "Observamos que a fatura que está sendo adicionada possui a mesma data de vencimento e\n        transportadora de uma fatura já registrada no sistema. Você prefere reenviar a fatura ou adicionar uma nova?\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Reenviar fatura:")]),
              _vm._v(
                " Isso substituirá a fatura existente pelo arquivo que está sendo adicionado."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Adicionar fatura:")]),
              _vm._v(
                " Isso permitirá que você visualize ambas as faturas da mesma transportadora"
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cfad558", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfad558","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/upload/components/BillingUploadSavingModal.vue
// module id = null
// module chunks = 